import { createReducer } from '@reduxjs/toolkit';
import { LoginData, RequestError } from 'types';
import { clearStateSlice } from '../clear-slice/actions';
import { login, logged, logout, logouted, setIsLoginExpired, setUserName } from './actions';

import { State } from './types';

export const INITIAL_STATE: State = {
  status: undefined,
  error: undefined,
  data: undefined,
  userName: undefined,
  isLoginExpired: undefined,
};

// https://redux-toolkit.js.org/api/createReducer#the-builder-callback-api
export default createReducer<State>(INITIAL_STATE, (builder) =>
  builder
    .addCase(login, (state) => {
      state.status = 'loading';
      state.data = undefined;
      state.error = undefined;
    })
    .addCase(logged, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.data = undefined;
        state.error = payload as RequestError;
        state.status = 'error';
      } else {
        state.data = payload as LoginData;
        state.error = undefined;
        state.status = 'success';
        state.isLoginExpired = false;
      }
    })

    .addCase(logout, (state) => {
      state.status = 'loading';
      state.data = undefined;
      state.error = undefined;
    })
    .addCase(logouted, () => {
      return INITIAL_STATE;
    })

    .addCase(setUserName, (state, action) => {
      const { payload } = action;
      state.userName = payload;
    })

    .addCase(setIsLoginExpired, (state, action) => {
      const { payload } = action;
      state.isLoginExpired = payload;
    })

    .addCase(clearStateSlice, (state, action) => {
      const { payload } = action;
      if (payload?.sliceReducer === 'APIAuth') {
        if (payload?.sliceKey) {
          return {
            ...state,
            [payload.sliceKey]: INITIAL_STATE[payload.sliceKey],
          };
        } else {
          return INITIAL_STATE;
        }
      }
      return state;
    })
);
